export default {
  landing: import.meta.env.VITE_LANDING_URL,
  minasidor: import.meta.env.VITE_MINASIDOR_URL,
  shop: import.meta.env.VITE_SHOP_URL,
};
